import { InjectionKey } from 'vue'
import { MultiEntityContext } from './types'

export const ASSET_CLASS = 'Asset Class'
export const INVESTMENT_STRATEGY = 'Investment Strategy'

export const MULTI_ENTITY_CONTEXT: InjectionKey<MultiEntityContext> = Symbol(
  'multiEntityContext',
)
